import React from 'react'

const Service = () => {
  return (
    <>
        
    <div className="container-fluid py-5 bgimg2">
        <div className="container pt-5 pb-3 ">
            <h1 className="display-4 text-uppercase text-center mb-5">Services I Offer</h1>
            <div className="row">
                <div className="col-lg-4 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-laptop-code text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">Web Design</span></h4>
                        <p className="m-0">Let us help you create a website and Mobile app or redesign one that stands out from the competition."</p>
                    </div>
                </div>
                <div className="col-lg-4 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-globe text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">App Development</span></h4>
                        <p className="m-0">Our SEO services can help improve your ranking and drive more traffic to your site.</p>
                    </div>
                </div>
                <div className="col-lg-4 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-people-arrows text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"> <span className="d-block text-body">Digital Marketing</span></h4>
                        <p className="m-0">making your website more social media-friendly, you are reaching more & more potential customers online & more sales.</p>
                    </div>
                </div>
                <div className="col-lg-4 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-edit text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">Blog and Article writing</span></h4>
                        <p className="m-0">If your blog posts are putting people to sleep, it's time to call in the experts. Let us help you create content that's both informative and engaging.</p>
                    </div>
                </div>
                <div className="col-lg-4 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-edit text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">SEO Management</span></h4>
                        <p className="m-0">Great online expericence happen only when a well planed SEO strategy visualized with top class algorithm.</p>
                    </div>
                </div>
                <div className="col-lg-4 mb-2">
                    <div className="service-item rounded p-4 mb-4">
                        <i className="fa fa-3x fa-edit text-primary mb-4"></i>
                        <h4 className="text-uppercase mb-4"><span className="d-block text-body">Hosting</span></h4>
                        <p className="m-0">it's time to call in the experts. Let us help you create content that's both informative and engaging.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    </>
  )
}

export default Service